import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import HOSLogo from './HOSLogo';

const links = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/products', label: 'Products' },
  { to: '/solutions', label: 'Solutions' },
  { to: '/contact', label: 'Contact' },
];

const navLink = ({ isActive }) =>
  `text-xs tracking-widest uppercase font-medium transition-all duration-200 pb-0.5 ${
    isActive
      ? 'text-[#D4AF37] border-b border-[#D4AF37]'
      : 'text-gray-700 hover:text-[#D4AF37]'
  }`;

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <nav className="fixed top-0 w-full z-50 bg-white shadow-sm border-b border-gray-100 h-20">
      <div className="max-w-7xl mx-auto px-8 h-full flex items-center justify-between">

        {/* Logo */}
        <Link to="/"><HOSLogo size={40} /></Link>

        {/* Desktop nav */}
        <ul className="hidden md:flex items-center gap-8">
          {links.map(l => (
            <li key={l.to}>
              <NavLink to={l.to} end={l.to === '/'} className={navLink}>
                {l.label}
              </NavLink>
            </li>
          ))}

          {user ? (
            <>
              {/* No Admin/Logout in public navbar — access admin via /admin/login */}
            </>
          ) : null}
        </ul>

        {/* Mobile toggle */}
        <button
          className="md:hidden text-gray-700 hover:text-[#D4AF37] transition-colors"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-gray-100 px-8 py-4 shadow-md">
          {links.map(l => (
            <NavLink
              key={l.to} to={l.to} end={l.to === '/'}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block py-3 text-xs tracking-widest uppercase font-medium border-b border-gray-100 transition-colors duration-200 ${
                  isActive ? 'text-[#D4AF37]' : 'text-gray-700 hover:text-[#D4AF37]'
                }`
              }>
              {l.label}
            </NavLink>
          ))}
          {/* Admin/Logout removed from public navbar */}
        </div>
      )}
    </nav>
  );
}
